import React from 'react';
import ReactMarkdown from 'react-markdown';

import { Card } from 'components/Card';
import ExpandableSection from 'components/ExpandableSection';
import Message from 'components/Message';
import { Title } from 'features/App';

import HowSmartRateWorks from './HowSmartRateWorks';
import { useSmartRateFaqsQuery } from './SmartRate.hooks';
import messages from './SmartRate.messages';

import './SmartRate.scss';

const SmartRate = () => {
  const { data: faqs = [], isLoading } = useSmartRateFaqsQuery();

  return (
    <>
      <Message message={messages.title} as={Title} />
      <HowSmartRateWorks />

      <Card className="smart-rate__faq-card" loading={isLoading}>
        <Message message={messages.faqTitle} as="h2" className="smart-rate__faq-title" />
        {faqs.length > 0 && (
          <div className="smart-rate__faq-list">
            {faqs.map(({ id, question, answer }) => (
              <ExpandableSection key={id} id={`smart-rate-faq-${id}`} title={question}>
                <ReactMarkdown className="smart-rate__faq-answer">{answer}</ReactMarkdown>
              </ExpandableSection>
            ))}
          </div>
        )}
      </Card>
    </>
  );
};

export default SmartRate;
